export const Error = ({ children }: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => (
    <div className="bg-red-700 text-white p-4 rounded text-center">{children}</div>
)
